// Vollea brand theme — exact tokens
export const C = {
  bg: "#000000",
  surface: "#111111",
  surface2: "#18181B",
  surface3: "#27272A",
  border: "#27272A",
  borderStrong: "#3F3F46",
  divider: "#27272A",
  text: "#FFFFFF",
  textMuted: "#A1A1AA",
  textDim: "#71717A",
  lime: "#A8E12B",
  limeSoft: "#C1F252",
  limeTint: "#2C3B0E",
  onLime: "#000000",
  warning: "#F59E0B",
  error: "#EF4444",
  success: "#A8E12B",
};

export const SP = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48 };
export const R = { sm: 6, md: 12, lg: 20, pill: 999 };

export const ROLE_LABELS = {
  player: "Player",
  club_admin: "Club Admin",
  league_organiser: "League Organiser",
  super_admin: "Super Admin",
};
